import { useEffect, useState } from "react";
import Modal from "./Modal";

export default function ModalNovoInsumo({ isOpen, onClose, onSave, initialData = null }) {
    const [nome, setNome] = useState("");
    const [unidade, setUnidade] = useState("un");
    const [alertaMinimo, setAlertaMinimo] = useState(1);

    useEffect(() => {
        if (initialData && initialData !== 1) {
            setNome(initialData.nome);
            setUnidade(initialData.unidade);
            setAlertaMinimo(initialData.quantidadeMinima);
        } else {
            setNome("");
            setUnidade("un");
            setAlertaMinimo(1);
        }
    }, [initialData, isOpen]);

    const handleSubmit = () => {
        if (!nome?.trim()) return;

        const novoInsumo = {
            id: initialData?.id || 0,
            nome,
            unidade,
            quantidadeMinima: alertaMinimo,
            quantidade: initialData?.quantidade || 0,
            historico: initialData?.historico || [],
            tipo: "insumo",
        };

        onSave(novoInsumo);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} size="w-full max-w-md" zIndex={50}>
            <h2 className="text-xl font-bold text-gray-800 mb-4">Novo Insumo</h2>

            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nome do Insumo</label>
                    <input
                        type="text"
                        className="w-full border rounded-md px-3 py-2 text-sm focus:ring focus:ring-blue-200 focus:outline-none"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        placeholder="Ex: Queijo mussarela"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Unidade</label>
                    <select
                        className="w-full border rounded-md px-3 py-2 text-sm focus:ring focus:ring-blue-200 focus:outline-none"
                        value={unidade}
                        onChange={(e) => setUnidade(e.target.value)}
                    >
                        <option value="un">Unidade (un)</option>
                        <option value="kg">Quilograma (kg)</option>
                        <option value="g">Grama (g)</option>
                        <option value="l">Litro (l)</option>
                        <option value="ml">Mililitro (ml)</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Alerta Mínimo</label>
                    <input
                        type="number"
                        className="w-full border rounded-md px-3 py-2 text-sm focus:ring focus:ring-blue-200 focus:outline-none"
                        value={alertaMinimo}
                        onChange={(e) => setAlertaMinimo(Number(e.target.value))}
                        min={1}
                    />
                </div>
            </div>

            <div className="mt-6 flex justify-end gap-2">
                <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm rounded-md border text-gray-700 hover:bg-gray-100"
                >
                    Cancelar
                </button>
                <button
                    onClick={handleSubmit}
                    className="px-4 py-2 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
                >
                    Salvar
                </button>
            </div>
        </Modal>
    );
}
